export default __webpack_public_path__ + "static/media/ofs_700_sal.addc3751.jpg";